// extracted by mini-css-extract-plugin
export default {"formWrapper":"ContactForm_formWrapper__ai9Dk","control":"ContactForm_control__SNVwi","button":"ContactForm_button__x3ZRx","image":"ContactForm_image__ucfXo"};